import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectAdfoxRequestedParams } from '../../../store/adfoxParams/selectors';
import { IAdFoxBannerTypeParams, TAdFoxBanner, TAdfoxParams } from '../../../types/adfox';
import { getAdfoxCalculatedParams, getAdfoxBannerTypeParams } from '../../../utils/adfox';
import { getRandomId } from '../../../utils/banners';

const PR_RANDOM = getRandomId();

/**
 * @deprecated Данная функция собирает старые параметры, которые больше не нужны.
 * Используйте {@see useAdfoxPuids}
 */
export function useAdfoxParamsLegacy(
  bannerType: TAdFoxBanner,
  randomId: string,
  additionalPuids: IAdFoxBannerTypeParams = {},
): TAdfoxParams | null {
  const adfoxRequestedParams = useSelector(selectAdfoxRequestedParams);

  return useMemo<TAdfoxParams | null>(() => {
    if (adfoxRequestedParams !== null && Boolean(process.env.IS_BROWSER_BUILD)) {
      const now = new Date();
      const dl = encodeURIComponent(document.location.toString());

      return Object.assign(
        {},
        adfoxRequestedParams,
        {
          dl,
          pd: now.getDate(),
          pr: PR_RANDOM,
          pr1: randomId,
          pv: now.getHours(),
          pw: now.getDay(),
          ...additionalPuids,
        },
        getAdfoxCalculatedParams(),
        getAdfoxBannerTypeParams(bannerType),
      );
    }

    return null;
  }, [additionalPuids, adfoxRequestedParams, bannerType, randomId]);
}
